import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Owns ephemeral, non-persisted "session context" supplied to the
 * assistant slideout by an external caller (e.g. a future mosaic action)
 * for the duration that a given agent's slideout session stays open.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'AssistantSessionContext',
      selectors: () => new Selectors(this),
    })
  }
}
